import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import React, { ReactNode } from 'react';
import { msalConfig } from '../config/msalConfig';

const msalInstance = new PublicClientApplication(msalConfig);

const MsalProviderCustom = ({ children }: { children: ReactNode }) => {
  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};

export default MsalProviderCustom;
